import { Currency } from '@40seas/models';
import { EnumSchema, FromSchema } from 'libs/entities/common/src/SchemaOperations';
import { z } from 'zod';

export const CreditSafeReportFinancialStatementSchema = z
    .object({
        netSales: z.number().optional(),
        otherOperationIncome: z.number().optional(),
        latestBalance: z.number().optional(),
        totalDebt: z.number().optional(),
        netIncome: z.number().optional(),
        employees: z.number().optional(),
        cashFlow: z.number().optional(),
        currency: EnumSchema(Currency).optional(),
        yearEndDate: z.date().optional(),
    })
    .strict();

export class CreditSafeReportFinancialStatement extends FromSchema(CreditSafeReportFinancialStatementSchema) {
    netSales?: number;
    otherOperationIncome?: number;
    latestBalance?: number;
    totalDebt?: number;
    netIncome?: number;
    employees?: number;
    cashFlow?: number;
    currency?: Currency;
    yearEndDate?: Date;
}
